// extracted by mini-css-extract-plugin
export var container = "_58-0";
export var icon = "_58-1";
export var text = "_58-2";